import "./FinanceHowItWorks.scss"

const FinanceHowItWorks = () => {
    return (
        <>
            <div className="financeHowItWorksOuterDiv">
                <div className="financeHowItWorksInnerDiv">
                    <div className="financeHowItWorksInnerDivOne">
                        <button className="financeHowItWorksBtn">
                            HOW IT WORKS
                        </button>
                        <p id="financeHowItWorksHeading">
                            Inspiring Innovation & Setting In Your Industry.
                        </p>
                    </div>
                    <div className="financeHowItWorksInnerDivTwo">
                        <div className="financeHowItWorksInnerDivTwoDivs">
                            <img src="../assets/img/finance/HowItWorksImg1.png" alt="About Us" id="financeAboutUsImage" />
                            <p id="heading"> Innovative Planning </p>
                            <p id="heading-description"> It is a long-established fact that a reader will be distracted by the readable content of a page site design work. </p>
                        </div>
                        <div className="financeHowItWorksInnerDivTwoDivs">
                            <img src="../assets/img/finance/HowItWorksImg2.png" alt="About Us" id="financeAboutUsImage" />
                            <p id="heading"> Integration Services </p>
                            <p id="heading-description"> It is widely recognized that a reader's attention is often drawn away by the visual content of a webpage's design. </p>
                        </div>
                        <div className="financeHowItWorksInnerDivTwoDivs">
                            <img src="../assets/img/finance/HowItWorksImg3.png" alt="About Us" id="financeAboutUsImage" />
                            <p id="heading"> Business Profit </p>
                            <p id="heading-description"> It is well-known that the visual elements of a webpage often distract a reader from the content itself. </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FinanceHowItWorks;